export const FINDING_ACTIVE_PROGRAMMES = 'Finding Active Programmes';
export const CREATING_MEMBER = 'Creating Member';
export const FLAGGING_MEMBER_AS_PAID = 'Flagging Member As Paid';
export const VERIFYING_MEMBER_STATUS = 'Verifying Member Status';
